let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("dMn8Q")]).then(() => parcelRequire('7naaD'));